import script from "./SelectMetal.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectMetal.vue?vue&type=script&setup=true&lang=js"

import "./SelectMetal.vue?vue&type=style&index=0&id=2c3c5d96&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c3c5d96"]])

export default __exports__